// Class: openfl.utils.IAssetCache

var $global = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : this

$global.Object.defineProperty(exports, "__esModule", {value: true});

var __map_reserved = {};

// Imports

var $hxClasses = require("./../../hxClasses_stub").default;
var $hxEnums = require("./../../hxEnums_stub").default;

// Constructor

var IAssetCache = function() {}

// Meta

IAssetCache.__name__ = "openfl.utils.IAssetCache";
IAssetCache.__isInterface__ = true;
IAssetCache.prototype = {
	
};
IAssetCache.prototype.__class__ = IAssetCache.prototype.constructor = $hxClasses["openfl.utils.IAssetCache"] = IAssetCache;

// Init



// Statics




// Export

exports.default = IAssetCache;